export default __webpack_public_path__ + "static/media/Alisha.49e29ffd.png";